import { render, staticRenderFns } from "./formClick2buy.vue?vue&type=template&id=7b087091&"
import script from "./formClick2buy.vue?vue&type=script&lang=js&"
export * from "./formClick2buy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports